export default __webpack_public_path__ + "static/media/5.26bdc1b9.svg";